var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-span-full row-span-1 rounded-t-lg bg-ds-button-secondary-background p-3",class:_vm.className},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }